export default __webpack_public_path__ + "static/media/CZ-RTC6BLW 1.06d61f8c.jpg";